import { render, staticRenderFns } from "./spd_multiple_blue_badge.vue?vue&type=template&id=1c07f7de"
import script from "./spd_multiple_blue_badge.vue?vue&type=script&lang=js"
export * from "./spd_multiple_blue_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports